export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Filters.vue?vue&type=template&id=38d89e74&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/QuotesTracking/Filters.vue?vue&type=template&id=38d89e74&scoped=true
// module id = 2447
// module chunks = 31